import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

//import { HttpModule}  from '@angular/http';
import { HttpClientModule } from '@angular/common/http'; 
import { AgmCoreModule } from '@agm/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  suppressScrollX: true               
};
import { CalendarModule } from 'angular-calendar';
import { SharedModule } from './shared/shared.module';
import { PipesModule } from './theme/pipes/pipes.module';
import { routing } from './app.routing';

import { AppComponent } from './app.component';
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { AppSettings } from './app.settings';

import { SidenavComponent } from './theme/components/sidenav/sidenav.component';
import { VerticalMenuComponent } from './theme/components/menu/vertical-menu/vertical-menu.component';
import { HorizontalMenuComponent } from './theme/components/menu/horizontal-menu/horizontal-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';
import { FlagsMenuComponent } from './theme/components/flags-menu/flags-menu.component';
import { FullScreenComponent } from './theme/components/fullscreen/fullscreen.component';
import { ApplicationsComponent } from './theme/components/applications/applications.component';
import { MessagesComponent } from './theme/components/messages/messages.component';
import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { ExcelService } from './excel.service';
import { BankImportService } from './pages/services/bank-import.service';

import { Retail, Housing, SME, Corporate } from './pages/master/master-constant';


import { EliminateDetailDialog } from './pages/collateral/estimate/estimate-detail-dialog';
import { InsuranceDetailDialog } from './pages/collateral/insurance/insurance-detail-dialog';

import { Master1DateDialog } from './pages/dialog/master1-date-dialog';
import { Master1TextDialog } from './pages/dialog/master1-text-dialog';
import { Master1NumberDialog } from './pages/dialog/master1-number-dialog';
//-- ------
import { AppApproveDialog } from './pages/application/approve/approve-dialog';
import { AppInformationDialog } from './pages/application/information/information-dialog';
import { AppUserPhotoDialog } from './pages/application/user-photo/user-photo-dialog';
//-- ------
import { InterestedDialog } from './pages/npa/npa-dialog/interested-dialog';
import { InterestedTalkDialog } from './pages/npa/npa-dialog/interested-talk-dialog';
import { NpaSaleDialog } from './pages/npa/npa-dialog/npa-sale-dialog';
import { NpaConfirmDialog } from './pages/npa/npa-dialog/npa-confirm-dialog';
import { NpaCancelDialog } from './pages/npa/npa-dialog/npa-cancel-dialog';
import { NpaSoldDialog } from './pages/npa/npa-dialog/npa-sold-dialog';
import { NpaNoteDialog } from './pages/npa/npa-dialog/npa-note-dialog';
import { NpaDateDialog } from './pages/npa/npa-dialog/npa-date-dialog';
import { NpaMaintenanceDialog } from './pages/npa/npa-dialog/npa-maintenance-dialog';
import { NpaInvasionDialog } from './pages/npa/npa-dialog/npa-invasion-dialog';
import { NpaUtilityDialog } from './pages/npa/npa-dialog/npa-utility-dialog';
//-- ------

import {
  SocialLoginModule,
  AuthServiceConfig,
  GoogleLoginProvider
} from "angular5-social-login";

export function getAuthServiceConfigs() {
  let config = new AuthServiceConfig([{
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider(
        "1092043926679-462pqq528dva23ehbc8ehhs02r30q67n.apps.googleusercontent.com")
  }]);
  //legaldev=="1092043926679-7im5bs52o4rmeu61f11e508ioaskbo78.apps.googleusercontent.com")
  //production--"1092043926679-462pqq528dva23ehbc8ehhs02r30q67n.apps.googleusercontent.com")
  //recovery--1092043926679-4vjqafru0k5bnncqfp6b4qgagsjvt6tm.apps.googleusercontent.com
  //dev--1092043926679-vmr7qahaflvvvc8ru619n354pdhp15bp.apps.googleusercontent.com
  //dev23--1092043926679-ms5svot3h41hs40ddh5dk8a2pmsc91a7.apps.googleusercontent.com

  
  return config;
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,     
    FormsModule, 
    ReactiveFormsModule,
    /*AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE'
    }), */
    PerfectScrollbarModule, 
    CalendarModule.forRoot(),
    SharedModule,
    PipesModule,
    //HttpModule,
    HttpClientModule,
    routing,
    SocialLoginModule
  ],
  declarations: [
    AppComponent,
    PagesComponent,
    BlankComponent,
    SearchComponent,
    NotFoundComponent,
    ErrorComponent,
    SidenavComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    BreadcrumbComponent,
    FlagsMenuComponent,
    FullScreenComponent,
    ApplicationsComponent,
    MessagesComponent,
    UserMenuComponent,
    EliminateDetailDialog,
    InsuranceDetailDialog,
    Master1DateDialog,
    Master1TextDialog,
    Master1NumberDialog,
    AppApproveDialog,
    AppInformationDialog,
    AppUserPhotoDialog,
    InterestedDialog,
    InterestedTalkDialog,
    NpaSaleDialog,
    NpaConfirmDialog,
    NpaCancelDialog,
    NpaSoldDialog,
    NpaNoteDialog,
    NpaDateDialog,
    NpaMaintenanceDialog,
    NpaInvasionDialog,
    NpaUtilityDialog,
  ],
  entryComponents:[
    VerticalMenuComponent,
    HorizontalMenuComponent,
    EliminateDetailDialog,
    InsuranceDetailDialog,
    Master1DateDialog,
    Master1TextDialog,
    Master1NumberDialog,
    AppApproveDialog,
    AppInformationDialog,
    AppUserPhotoDialog,
    InterestedDialog,
    InterestedTalkDialog,
    NpaSaleDialog,
    NpaConfirmDialog,
    NpaCancelDialog,
    NpaSoldDialog,
    NpaNoteDialog,
    NpaDateDialog,
    NpaMaintenanceDialog,
    NpaInvasionDialog,
    NpaUtilityDialog,
  ],
  providers: [ 
    AppSettings,
    ExcelService, BankImportService,
    Retail, Housing, SME, Corporate, 
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: AuthServiceConfig, useFactory: getAuthServiceConfigs }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
